import {EmployeeRef} from "../../api/Model";
import {CardMedia, CardMediaProps, Skeleton} from "@mui/material";
import {cachedImageStore} from "../../api/CachedImageStore";
import {Loading} from "../loading-data/LoadingData";

export function EmployeeCardMedia({employee, ...props}: {
    employee: EmployeeRef,
} & CardMediaProps<'img'>) {
    const avatarUrl = cachedImageStore.get(`/employees/${employee.id}/avatar?size=${props.height || 240}`);

    return (
        <Loading
            loading={
                <Skeleton variant="rectangular" width="100%" animation="wave">
                    <CardMedia
                        component="img"
                        alt={employee.fullName}
                        height={props.height || 240}
                        {...props}
                    />
                </Skeleton>
            }
            value={avatarUrl}
        >{avatarUrl =>
            <CardMedia
                component="img"
                alt={employee.fullName}
                height={props.height || 240}
                image={avatarUrl}
                sx={{
                    filter: employee.deactivated ? 'grayscale(100%)' : undefined,
                    opacity: employee.deactivated ? 0.5 : undefined,
                    ...props.sx,
                }}
                {...props}
            />
        }</Loading>
    )
}